import httpService from "./httpService";

export const podCastSubmissionData = (data: any) => {
  return httpService.post("user/podcast/store", data);
};

export type BlogListParams = {
  search?: string;
  category?: string | number;
  stage?: string | number;
  page?: number | string;
  per_page?: number;
};

export const getBlogListApi = (params: BlogListParams = {}) => {
  return httpService.post("blog", params);
};

export const getBlogFiltersApi = () => {
  return httpService.post("blog/filters");
};

export const getBlogDetailApi = (slug: string) => {
  return httpService.post(`blog/${slug}`);
};

export const subscribeNewsletterApi = (email: string) => {
  return httpService.post("user/newsletter/store", { email });
};
